import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { SetStockOpeningEdit } from "../../store/stockOpeningAtom";
import { stockService } from "../../services/stockService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import StockViewScroll from "./StockViewScroll";
import { IoMdRefresh } from "react-icons/io";


import StockHistoryTab from "./StockHistoryTab";
import StockLineItemsTab from "./StockLineItemsTab";

const StockViewDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setStockEdit = SetStockOpeningEdit();

  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [stockDetailsList, setStockDetailsList] = useState([]);
  const [fullStockData, setFullStockData] = useState(null);
  const [activeTab, setActiveTab] = useState("line-items");

  const { pathname } = useLocation();
  const printRef = useRef(null);

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "Stock View Details";
    let isMounted = true;

    if (isMounted) {
      loadDetailsData();
    }

    return () => {
      isMounted = false;
    };
  }, [id]);

  const loadDetailsData = () => {
    stockService.stockViewDetails(id).then((response) => {
      console.log("Stock_view ", response.data);
      const serverData = response.data;

      setFullStockData(serverData);
      if (serverData?.stock_info?.length) {
        setStockDetailsList(serverData?.stock_info);
      }
    });
  };



  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Stock_View_${fullStockData?.opening_main?.[0]?.ref_no || id}`,
    onAfterPrint: () => console.log("Printed successfully"),
  });

  const onSelection = (list) => {
    const tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

  const viewItemDetails = useCallback(
    (adId) => {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
    },
    [currModuleId, currModuleName, navigate]
  );

  return (
    <section className="mt-4 w-full mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-end gap-3 mb-6">


           <button
            onClick={loadDetailsData}
            className="p-2 rounded-full  shadow-md hover:bg-gray-100 transition-colors"
            title="Refresh"
          >
            {/* <IoMdRefresh className="h-5 w-5 text-gray-600" /> */}
            <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
          </button>


        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          <img src={printer} alt="Print" className="w-5 h-5" />
          <span className="hidden sm:inline">Print</span>
        </button>
      </div>

      <div className="flex flex-col lg:flex-row gap-2">
        <div className="w-20 xl:w-20">
          <StockViewScroll onSelection={onSelection} viewItemDetails={viewItemDetails} />
        </div>

        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl overflow-hidden max-w-[1400px]">
          <div className="p-6 lg:p-8">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-4 mb-6">
              <div>
                <h1 className="text-2xl font-bold text-gray-800">Stock View Details</h1>
                <p className="text-sm text-gray-500 mt-1">
                  Ref No: {fullStockData?.opening_main?.[0]?.ref_no || "-"}
                </p>
              </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200 mb-6">
              <nav className="flex -mb-px gap-8">
                    <button
                  onClick={() => setActiveTab("line-items")}
                  className={`pb-3 text-sm font-semibold border-b-2 transition-all ${
                    activeTab === "line-items"
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Line Items
                </button>
                <button
                  onClick={() => setActiveTab("history")}
                  className={`pb-3 text-sm font-semibold border-b-2 transition-all ${
                    activeTab === "history"
                      ? "border-blue-600 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700"
                  }`}
                >
                  History
                </button>
            
              </nav>
            </div>

            {activeTab === "history" && (
              <StockHistoryTab
              id={id}
                stockDetailsList={stockDetailsList}
                formatCustomNumber={formatCustomNumber}
              />
            )}

            {activeTab === "line-items" && (
              <StockLineItemsTab
                stockDetailsList={stockDetailsList}
                formatCustomNumber={formatCustomNumber}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StockViewDetailsPage;